//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheHeader from "./components/TheHeader.vue";
import MobileHeader from "./components/MobileHeader.vue";
import TheFooter from "./components/TheFooter.vue";
import AuthenticationPopup from "./components/AuthenticationPopup.vue";
import PartnerHeader from "./components/partners/TheHeader.vue";
import PartnerMobileHeader from "./components/partners/MobileHeader.vue";

export default {
  name: "DefaultLayout",
  components: {
    TheHeader,
    MobileHeader,
    TheFooter,
    AuthenticationPopup,
    PartnerHeader,
    PartnerMobileHeader,
  },
  data() {
    return {
      sidebarOpen: false,
      links: [
        { slug: "", title: "Overview", links: [] },
        { slug: "dashboard", title: "Dashboard", links: [] },
        {
          slug: "rileva-impresa",
          title: "RilevaImpresa",
          links: [
            {
              slug: "accedere-rileva-impresa",
              title: "Accedere a RilevaImpresa",
            },
            {
              slug: "navigare-applicazione-rileva-impresa",
              title: "Navigare nell'applicazione RilevaImpresa",
            },
            {
              slug: "creazione-del-questionario",
              title: "Creazione del questionario",
            },
            {
              slug: "inviare-questionario",
              title: "Inviare un questionario al cliente",
            },
            {
              slug: "consultazione-risposte",
              title: "Consultazione delle risposte ai questionari",
            },
          ],
        },
        {
          slug: "aggiunta-nuovo-cliente",
          title: "Aggiunta di un Nuovo Cliente",
          links: [],
        },
        {
          slug: "sviluppa-impresa",
          title: "Consulenza ad un Cliente: SviluppaImpresa",
          links: [
            {
              slug: "modificare-costi-locale",
              title: "Modificare i Costi del Locale",
              links: [
                {
                  slug: "aggiornare-servizi-richiesti",
                  title: "Aggiornare i Servizi Richiesti",
                },
                {
                  slug: "impostare-parametri-apertura",
                  title: "Impostare i Parametri di Apertura",
                },
                {
                  slug: "definire-sala",
                  title: "Definire la Sala",
                },
                {
                  slug: "aggiungere-modificare-spese",
                  title: "Aggiungere e Modificare Spese",
                },
                {
                  slug: "controllare-totali",
                  title: "Controllare i Totali",
                },
              ],
            },
            {
              slug: "modificare-menu",
              title: "Modificare il Menù",
              links: [
                {
                  slug: "rinominare-menu",
                  title: "Rinominare il Menù",
                },
                {
                  slug: "selezionare-tipo-ricarico",
                  title: "Selezionare il Tipo di Ricarico",
                },
                {
                  slug: "modificare-voci-menu",
                  title: "Inserire o Modificare le Voci del Menù",
                },
                {
                  slug: "aggiornare-ordine-tipico",
                  title: "Aggiornare l'Ordine Tipico",
                },
                {
                  slug: "navigare-pagine",
                  title: "Navigare tra le Pagine",
                },
              ],
            },
            {
              slug: "analisi-locale",
              title: "Studiare l'Analisi del Locale",
              links: [
                {
                  slug: "pannello-controllo",
                  title: "Pannello di Controllo",
                },
                {
                  slug: "costi-ricavi",
                  title: "Costi e Ricavi",
                },
                {
                  slug: "analisi-scenari",
                  title: "Analisi a Scenari",
                },
                {
                  slug: "percentuali",
                  title: "Percentuali",
                },
                {
                  slug: "analisi-menu",
                  title: "Analisi del Menù",
                },
              ],
            },
            {
              slug: "risolvere-problemi",
              title: "Risolvere i Problemi Riscontrati",
            },
          ],
        },
        {
          slug: "monitora-impresa",
          title: "Monitoraggio di un Cliente: MonitoraImpresa",
          links: [
            {
              slug: "report-mensili",
              title: "Report Mensili",
            },
            {
              slug: "dashboard",
              title: "Dashboard",
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleClick(e) {
      const target = event.target.closest("[data-open]");

      if (target) {
        const currentValue = target.getAttribute("data-open");

        const isSecondLevel = !!target.getAttribute("data-second-id");

        if (currentValue === "false") {
          // Set the data-open of all other elements to false

          let allElements = document.querySelectorAll("[data-open]");

          if (isSecondLevel) {
            const parent = target.closest("[data-first-id]");
            const parentId = parent.getAttribute("data-first-id");

            allElements = document.querySelectorAll(
              `[data-open]:not([data-first-id="${parentId}"])`
            );
          }

          allElements.forEach((element) => {
            if (element !== target) {
              element.setAttribute("data-open", "false");
            }
          });

          // Set the target's data-open to true
          target.setAttribute("data-open", "true");
        } else {
          // If it's already true, toggle it to false (optional behavior)
          target.setAttribute("data-open", "false");
        }
      }
    },
  },
  watch: {
    $route() {
      this.sidebarOpen = false;
    },
  },
};
